import React from "react";
import clsx from "clsx";

interface PlusIconProps {
    className?: string;
}

const PlusIcon = (props: PlusIconProps) => {
    return (
        <svg className={clsx("PlusIcon", props.className)} fill="currentColor" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
            <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
        </svg>
    );
};

export default PlusIcon;
